// src/components/ProtectedRoute.tsx
import { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { getLoginPath } from '../utils/domainConfig';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const isLoggedIn = localStorage.getItem('authToken');
  return isLoggedIn ? children : <Navigate to={getLoginPath()} replace />;
};

export default ProtectedRoute;
